import React, {useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setContent, removeContent, setFormValue } from './PatientEnrollmentSlice';
import inputStyles from '../program-management/ProgramManagement.module.css';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getInitialStartTime, initSelectedContent } from '../../utils/programUtils';
import Logger from '../../services/Logger';
import { LogElements, LogAction } from '../../services/LogElements';

const ContentEnrollment = ({ errors }) => {
    const {reenrolling, viewing, enrollment} = useSelector((state)=>state.enrollPatientProgram);
    const allContent = useSelector((state)=>state.enrollmentLists.content); // all available content
    const filteredContent = allContent.filter((content)=> enrollment.groups.some((group)=> group.groupId === content.groupId));
    const dispatch = useDispatch();
    const contentNotes = useSelector((state)=>state.enrollPatientProgram.contentNotes);
    const enrollmentContent = useSelector((state)=>state.enrollPatientProgram.contents); // all content in program/enrollment
    const [count, setCount] = useState(0);

    const [selectedContent, setSelectedContent] = useState(initSelectedContent(enrollmentContent, allContent));

    const checkSelectedItem = (id) => {
        let contentInList = false;
        selectedContent.forEach((item)=>{
            if (item.id===id){
                contentInList=true;
            } 
        });
        return contentInList;
    };

    const handleContentChange = (content) => {
        // Log content selection with content name as custom message
        Logger.shared.info(
            LogElements.contentDropdown,
            LogAction.clicked,
            'ContentEnrollment.js',
            content.name
        );
        
        let contentInList = false;
        selectedContent.forEach((item)=>{
            if (item.id===content.id){
                contentInList = true;
            } 
        });
        if (contentInList){
            setSelectedContent(selectedContent.filter(item => item.id !== content.id));
            dispatch(removeContent(content.id))
        } else {
            setSelectedContent([content, ...selectedContent]);
            let id = content.id;
            dispatch(setContent({
                id, 
                startTime: getInitialStartTime(),
                frequency: 1,
                interval: "Day"
            }));
        }
    };

    const removeContentCard = (id) => {
        setSelectedContent(selectedContent.filter(item => item.id !== id));
        dispatch(removeContent(id));
    };

    const handleNotes = (e) => {
        setCount(e.target.value.length);
        dispatch(setFormValue({key:"contentNotes",value:e.target.value}));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingBottom:"10px" }}>
             <MultiSelectDropdown 
                options={filteredContent}
                label='name'
                checkedKey='id'
                checkSelectedItem={checkSelectedItem}
                handleChange={handleContentChange}
                selectedItems={selectedContent}
                name='Content'
                disabled={reenrolling || viewing}
            />
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                {selectedContent.map((content, index) => (
                    <div key={content.id}>
                        <ManagementDropdownCard 
                            open={index!==0 ? false : true} 
                            cardInfo={{title:content.name, id:content.id, type:"Content"}}
                            removeHandler={removeContentCard}
                            updateHandler={setContent}
                            dataList={enrollmentContent}
                            errorShowing={errors.contentShowing}
                            disabled={reenrolling || viewing}
                        />
                    </div>
                ))}
                {selectedContent.length >= 1 &&
                    <div style={{position: "relative", display:"flex", flexDirection:"column", width:"300px", paddingTop:"20px"}}>
                        <span className={inputStyles.FloatingLabel}>Notes</span>
                        <textarea className={inputStyles.NoteInput} 
                            id="description"
                            type="text"
                            maxLength={250}
                            disabled={reenrolling || viewing}
                            defaultValue={contentNotes}
                            onChange={e => handleNotes(e)}
                        >
                        </textarea>
                        <span style={{fontSize:"10px", color:"#929395", marginLeft:"auto"}}>
                            {count}/250
                        </span>
                    </div>
                }
            </div>
        </div>
    )
}

export default ContentEnrollment;